import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h-60" }
const _hoisted_2 = { class: "block w-full" }
const _hoisted_3 = { class: "groupTitle" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_5 = { class: "inputTitle" }
const _hoisted_6 = { class: "inputField flex-grow" }
const _hoisted_7 = { class: "error-msg" }
const _hoisted_8 = { class: "inputTitle" }
const _hoisted_9 = { class: "inputField flex-grow" }
const _hoisted_10 = { value: "Abmeldung" }
const _hoisted_11 = { value: "Anmeldung" }
const _hoisted_12 = { value: "ATBEntry" }
const _hoisted_13 = { class: "error-msg" }
const _hoisted_14 = { class: "inputTitle" }
const _hoisted_15 = { class: "inputField flex-grow" }
const _hoisted_16 = { class: "error-msg" }
const _hoisted_17 = { class: "inputTitle" }
const _hoisted_18 = { class: "inputField flex-grow" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "POST" }, "POST", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "PUT" }, "PUT", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "error-msg" }
const _hoisted_23 = { class: "inputTitle" }
const _hoisted_24 = { class: "inputField flex-grow" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "application/json" }, "JSON (application/json)", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "text/csv" }, "CSV (text/csv)", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "application/xml" }, "XML (application/xml)", -1)
const _hoisted_28 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "col-span-2" }
const _hoisted_30 = { class: "inputTitle" }
const _hoisted_31 = { class: "inputField flex-grow" }
const _hoisted_32 = { class: "inputTitle" }
const _hoisted_33 = { class: "inputField flex-grow" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "None" }, "Inherit From Parent", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "Null" }, "Without Credential", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "ApiKey" }, "ApiKey", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: "OAuth2" }, "OAuth2", -1)
const _hoisted_38 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "inputTitle" }
const _hoisted_41 = { class: "inputField flex-grow" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "inputTitle" }
const _hoisted_44 = { class: "inputField flex-grow" }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { class: "inputTitle" }
const _hoisted_47 = { class: "inputField flex-grow" }
const _hoisted_48 = { key: 3 }
const _hoisted_49 = { class: "inputTitle" }
const _hoisted_50 = { class: "inputField flex-grow" }
const _hoisted_51 = { key: 4 }
const _hoisted_52 = { class: "inputTitle" }
const _hoisted_53 = { class: "inputField flex-grow" }
const _hoisted_54 = {
  key: 0,
  class: "contextError errorType rounded mt-4 text-sm"
}

import { computed, onMounted, ref, toRef } from "vue";
    import { helpers, required } from "@vuelidate/validators";
    import useVuelidate from "@vuelidate/core";
    import { useGlobalStore } from "@/stores/GlobalStore";
    import { useI18n } from "vue-i18n";
    import { SubscriptionInfo } from "../../../models/webhook/SubscriptionInfo";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NewSubscription',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as { data: SubscriptionInfo }

    const showProducerId = false;
    const globalStore = useGlobalStore();
    const { t } = useI18n();

    
    const popupData = toRef(props, "data");
    const cleanUpSubsciption = (paramData) => {
        if (paramData.value.authType !== "ApiKey")
            paramData.value.apiKey = null;
        if (paramData.value.authType !== "OAuth2") {
            paramData.value.oAuthTokenEndpoint = null;
            paramData.value.oAuthClientId = null;
            paramData.value.oAuthClientSecret = null;
            paramData.value.oAuthScope = null;
        }
    };
    onMounted(() => {
        globalStore.modal.validator = v$;
        cleanUpSubsciption(popupData);
});

    // Validation
    const rules = computed(() => {
        return {
            producerId: { required: helpers.withMessage(t("validators.required"), required) },
            eventType: { required: helpers.withMessage(t("validators.required"), required) },
            targetUrl: { required: helpers.withMessage(t("validators.required"), required) },
            httpMethod: { required: helpers.withMessage(t("validators.required"), required) },

        };
    });

    const v$ = ref(useVuelidate(rules, popupData));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('webhook.newSubscription')), 1),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('webhook.producerId')) + " * ", 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.producerId.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(popupData).producerId) = $event)),
                class: "w-full",
                disabled: ""
              }, null, 512), [
                [_vModelText, _unref(popupData).producerId]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.producerId.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ], 512), [
          [_vShow, showProducerId]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "hidden",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(popupData).subscriberId) = $event))
        }, null, 512), [
          [_vModelText, _unref(popupData).subscriberId]
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('webhook.eventType')) + " * ", 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.eventType.$errors.length })
            }, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupData).eventType) = $event)),
                class: "w-full"
              }, [
                _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t('webhook.unregister')), 1),
                _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('webhook.register')), 1),
                _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('webhook.atbEntry')), 1)
              ], 512), [
                [_vModelSelect, _unref(popupData).eventType]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.eventType.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('webhook.targetUrl')) + " * ", 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.targetUrl.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(popupData).targetUrl) = $event)),
                class: "w-full",
                placeholder: "https://..."
              }, null, 512), [
                [_vModelText, _unref(popupData).targetUrl]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.targetUrl.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('webhook.httpMethod')) + " * ", 1),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.httpMethod.$errors.length })
            }, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(popupData).httpMethod) = $event)),
                class: "w-full"
              }, _hoisted_21, 512), [
                [_vModelSelect, _unref(popupData).httpMethod]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.httpMethod.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('webhook.contentType')), 1),
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(popupData).contentType) = $event)),
              class: "w-full"
            }, _hoisted_28, 512), [
              [_vModelSelect, _unref(popupData).contentType]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('webhook.payloadTemplate')) + " * ", 1),
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(popupData).payloadTemplate) = $event)),
              class: "w-full",
              rows: "5",
              placeholder: "{ \"id\": \"{{id}}\" }"
            }, null, 512), [
              [_vModelText, _unref(popupData).payloadTemplate]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('webhook.authType')), 1),
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(popupData).authType) = $event)),
              class: "w-full"
            }, _hoisted_38, 512), [
              [_vModelSelect, _unref(popupData).authType]
            ])
          ])
        ]),
        (_unref(popupData).authType === 'ApiKey')
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('webhook.apiKey')), 1),
              _createElementVNode("div", _hoisted_41, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(popupData).apiKey) = $event)),
                  class: "w-full"
                }, null, 512), [
                  [_vModelText, _unref(popupData).apiKey]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(popupData).authType === 'OAuth2')
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('webhook.oAuthTokenEndpoint')), 1),
              _createElementVNode("div", _hoisted_44, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(popupData).oAuthTokenEndpoint) = $event)),
                  class: "w-full"
                }, null, 512), [
                  [_vModelText, _unref(popupData).oAuthTokenEndpoint]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(popupData).authType === 'OAuth2')
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('webhook.oAuthClientId')), 1),
              _createElementVNode("div", _hoisted_47, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(popupData).oAuthClientId) = $event)),
                  class: "w-full"
                }, null, 512), [
                  [_vModelText, _unref(popupData).oAuthClientId]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(popupData).authType === 'OAuth2')
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('webhook.oAuthClientSecret')), 1),
              _createElementVNode("div", _hoisted_50, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(popupData).oAuthClientSecret) = $event)),
                  class: "w-full"
                }, null, 512), [
                  [_vModelText, _unref(popupData).oAuthClientSecret]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(popupData).authType === 'OAuth2')
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('webhook.oAuthScope')), 1),
              _createElementVNode("div", _hoisted_53, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(popupData).oAuthScope) = $event)),
                  class: "w-full"
                }, null, 512), [
                  [_vModelText, _unref(popupData).oAuthScope]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(popupData).userInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_unref(popupData).userInfo), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})